import { render } from "./FilterFormSidebar.vue?vue&type=template&id=36f7c8be"
import script from "./FilterFormSidebar.vue?vue&type=script&lang=js"
export * from "./FilterFormSidebar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__